import Select from '@app/src/components/Form/Select/ControlledSelect'
import type { AnswerFlagFormData } from '@app/src/pages/Configurations/ConfigurationsPages/AnswerFlag/CreateAnswerFlagModal'
import { ANSWER_FLAG_FORM_KEYS } from '@app/src/pages/Configurations/ConfigurationsPages/AnswerFlag/CreateAnswerFlagModal'
import { RiskStatus } from '@app/src/types/resourceExplorer'
import { getRiskStatusTranslationKey } from '@app/src/utils/riskStatusHelpers'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

const SELECTABLE_RISK_STATUSES = [RiskStatus.High, RiskStatus.Extreme]

const AnswerFlagSeverity: React.FC = () => {
  const { formatMessage } = useIntl()
  const { control } = useFormContext<AnswerFlagFormData>()

  const riskStatusOptions = SELECTABLE_RISK_STATUSES.map(riskStatus => ({
    label: formatMessage({ id: getRiskStatusTranslationKey(riskStatus) }),
    value: riskStatus,
  }))

  return (
    <Select<string>
      name={ANSWER_FLAG_FORM_KEYS.RISK_STATUS}
      fieldLabel={formatMessage({ id: 'answerFlagRules.creation.severity.selectPlaceholder' })}
      control={control}
      required
      options={riskStatusOptions}
    />
  )
}

export default AnswerFlagSeverity
